import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterStateSnapshot } from '@angular/router';
import { PatientService } from '../../services';
import { AuthService } from '../../services/auth.service';
import { DialogComponent } from '../dialog/dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TransalteLangugaeService } from 'src/app/services/transalte-langugae.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  hub_id: string;
  hub_description: string;
  pNumber: string;
  pauseMonitoring = false;
  routerStateSnapshot: any;
  pauseDialogRef: any;
  playDialogRef: any;
  hubdialogRef: any;
  riskCount: any;
  statistics_datasource: any;
  showImage: boolean = true;
  subdomain: any;
  userImg: any;
  orgImg: any;
  navigationUrl: any;
  presentVersionBuild: any;
  constructor(
    private router: Router,
    public patientService: PatientService,
    public auth: AuthService,
    public dialog: MatDialog,
    private translate: TranslateService,
  ) {
    //this.init()
    this.routerStateSnapshot = this.router.routerState.snapshot;
  }

  ngOnInit(): void {
    this.subdomain = localStorage.getItem('base_org');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.userAdmin();
        this.Organization();
      }
    });
    this.patientService.currentVersion.subscribe((build) => {
      this.presentVersionBuild = build;
    })
    this.userAdmin();
    this.Organization();
  }

  userAdmin() {
    let item = localStorage.getItem('user');
    if (item === 'admin' || item === 'superadmin') {
      this.userImg = 'assets/images/user-admin.png';
    } else {
      this.userImg = null;
    }
  }

  hasRoute(route: string): boolean {
    return this.router.url.includes(route);
  }

  isHelpAvailable(): boolean {
    if (this.hasRoute('help')) {
      return false;
    }
    return this.hasRoute('dashboard') || this.hasRoute('connector') || this.hasRoute('login') || this.router.url === '/';
  }

  navigateToConnection(): void {
    // if (this.auth.isTokenValid()) {
    //this.isDropdownOpen = false;
    this.patientService.emitLogoutEvent();
    let dialogRef: any;
    dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      data: {
        type: 'alert',
        headerImg: 'assets/images/closeIcon.png',
        buttonsAlign: 'horizantal',
        label: `<h1>${this.translate.instant('Logout.label')}</h1>`,
        yesBtn: 'Confirm',
        cancelBtn: 'Cancel',
      },
    });
    const dialogSubscriber = dialogRef?.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        localStorage.removeItem('checkboxState');
        localStorage.removeItem('visualizeClickedObj');
        localStorage.removeItem('domain');
        localStorage.removeItem('hub_id');
        localStorage.removeItem('hub_description');
        localStorage.removeItem('user');
        localStorage.removeItem('selectedDataFilters');
        localStorage.removeItem('selectedRiskFilters');
        localStorage.removeItem('sortingData');
        localStorage.removeItem('base_org');
        localStorage.removeItem('token');
        localStorage.removeItem('monitoringTimeObj');
        localStorage.removeItem('time');
        localStorage.removeItem('hubIdData');
        localStorage.removeItem('pId');
        localStorage.removeItem('lang');
        //localStorage.removeItem('api_url');
        //localStorage.removeItem('refreshtoken');

        this.router.navigateByUrl('');
      }
    });

    // } else {
    //   this.auth.refreshToken();
    // }

  }
  user_role() {
    this.router.navigate(['/admin']);
  }
  Organization() {
    let org = localStorage.getItem('user');
    if (org === 'superadmin') {
      this.orgImg = 'assets/images/organization.png';
    } else {
      this.orgImg = null;
    }
  }
  navigateToOrganization() {
    if (this.auth.isTokenValid()) {
      this.router.navigate(['organization']);
    } else {
      this.auth.refreshToken();
    }
  }
  onAddDevice(): void {
    this.patientService.emitPairDeviceEvent();
  }

  onUnpairDevice(): void {
    this.patientService.emitUnpairDeviceEvent();
  }

  isUserLoggedIn(): boolean {
    if (this.router.url.includes('from=login')) {
      return false;
    }
    return this.auth.isTokenValid();
  }

  navigateToLogin(): void {
    this.router.navigate(['/login']);
  }

  fileOpen() {
    if (this.hasRoute('login') || this.router.url === '/') {
      this.router.navigate(['/help'], { queryParams: { from: 'login' } });
    } else {
      this.router.navigate(['/help']);
    }
  }
  navigateTODashboard() {
    if (this.auth.isTokenValid) {
      let dialogRef: any;
      dialogRef = this.dialog.open(DialogComponent, {
        width: '430px',
        data: {
          type: 'alert',
          headerImg: 'assets/images/closeIcon.png',
          buttonsAlign: 'horizantal',
          label: `${this.translate.instant('connectorToDashboard.label')}`,
          yesBtn: `${this.translate.instant('connectorToDashboard.yes')}`,
          cancelBtn: `${this.translate.instant('connectorToDashboard.no')}`,
        },
      });
      const dialogSubscriber = dialogRef?.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          this.updateDashboard();
        }
      });
    } else {
      this.auth.refreshToken();
    }
  }

  navigateDashboard() {
    if (this.auth.isTokenValid) {
      let dialogRef: any;
      dialogRef = this.dialog.open(DialogComponent, {
        width: '430px',
        data: {
          type: 'alert',
          headerImg: 'assets/images/closeIcon.png',
          buttonsAlign: 'horizantal',
          label: `${this.translate.instant('adminToDashboard.label')}`,
          yesBtn: `${this.translate.instant('connectorToDashboard.yes')}`,
          cancelBtn: `${this.translate.instant('connectorToDashboard.no')}`,
        },
      });
      const dialogSubscriber = dialogRef?.afterClosed().subscribe((result) => {
        if (result === 'yes') {
          this.updateDashboard();
          //this.router.navigate([`/${this.subdomain}/dashboard`]);
        }
      });
    } else {
      this.auth.refreshToken();
    }
  }

  updateDashboard(): void {
    this.subdomain = localStorage.getItem('base_org');
    this.navigationUrl = `/${this.subdomain}/dashboard`;
    this.router.navigateByUrl(this.navigationUrl);
  }

}